import { Zone } from "./types/types";

export const zoneMapping: Zone[] = [
  { id: 0, name: "Bozen und Umgebung", chapterIds: [53, 3, 24, 48, 8, 11] },
  { id: 1, name: "Eggental", chapterIds: [58, 36] },
  { id: 2, name: "Überetsch", chapterIds: [99, 61, 4, 55, 93] },
  { id: 3, name: "Unterland", chapterIds: [56, 69, 100, 45, 57, 107, 13, 28] },
  { id: 4, name: "Nonsberg", chapterIds: [60] },
  {
    id: 5,
    name: "Meran und Burggrafenamt",
    chapterIds: [98, 104, 65, 20, 46, 51, 22, 9, 75, 21, 95, 96, 29],
  },
  { id: 6, name: "Ulten", chapterIds: [30] },
  { id: 7, name: "Passeier", chapterIds: [34, 83, 88, 90] },
  {
    id: 8,
    name: "Vinschgau",
    chapterIds: [44, 26, 37, 47, 50, 86, 84, 6, 79, 87],
  },
  {
    id: 9,
    name: "Pustertal",
    chapterIds: [
      103, 42, 2, 7, 27, 73, 74, 76, 78, 71, 77, 17, 35, 89, 92, 97, 14,
    ],
  },
  { id: 10, name: "Gadertal", chapterIds: [5, 54, 105, 59, 66, 91] },
  { id: 11, name: "Wipptal", chapterIds: [102, 25, 80, 82, 41] },
  {
    id: 12,
    name: "Eisacktal",
    chapterIds: [101, 81, 62, 63, 43, 10, 49, 18, 72, 12, 31, 32, 64],
  },
  { id: 13, name: "Schlerngebiet", chapterIds: [70, 85, 94, 23] },
  { id: 14, name: "Sarntal", chapterIds: [19] },
  { id: 15, name: "Gröden", chapterIds: [1] },
];
